module.exports = __webpack_public_path__ + "static/media/illustration-heartbroken.28337b1c.svg";